module.exports = __webpack_public_path__ + "img/myaeon.3569f1c5.png";